import { render, staticRenderFns } from "./AddOrUpdateDrugAttributeModal.vue?vue&type=template&id=7aa9eedc&"
import script from "./AddOrUpdateDrugAttributeModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateDrugAttributeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateDrugAttributeModal.vue?vue&type=style&index=0&id=7aa9eedc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports